import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getDisplayDate } from '../../../utilities/displayFunctions';
import { css } from 'emotion';
import DiffInfoItem from './DiffInfoItem';
import { utcToLocalDateTime } from '../../../utilities/dateFunctions';

const containerStyle = css`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-height: 300px;
  height: 100%;
`;
class InfoChanges extends Component {
  static defaultProps = {};

  static propTypes = {
    from: PropTypes.object.isRequired,
    to: PropTypes.object.isRequired
  };

  state = {};

  render() {
    const { from, to } = this.props;

    const mappings = [
      {
        selector: 'additionalData.name',
        name: 'contract name'
      },
      {
        selector: 'displayAgreementType',
        name: 'agreement type'
      },
      {
        selector: 'status'
      },
      {
        selector: 'additionalData.gracePeriodConfiguration',
        name: 'grace period',
        renderText: ({ term }) =>
          !term.additionalData.gracePeriodConfiguration
            ? 'No Grace Period'
            : term.additionalData.gracePeriodConfiguration.period +
              ' ' +
              term.additionalData.gracePeriodConfiguration.unit
      },
      {
        selector: 'effectiveStartDate',
        name: 'effective start date',
        renderText: ({ value }) => getDisplayDate(value)
      },
      {
        selector: 'effectiveEndDate',
        name: 'effective end date',
        renderText: ({ value }) => getDisplayDate(value)
      },
      {
        selector: 'seller',
        renderText: ({ term }) => `${term.seller.name} (${term.seller.type})`
      },
      {
        selector: 'buyer',
        renderText: ({ term }) => `${term.buyer.name} (${term.buyer.type})`
      },
      {
        selector: 'createdAt',
        name: 'updated at',
        renderText: ({ value }) => utcToLocalDateTime(value)
      },
      {
        selector: 'createdByEmail',
        name: 'updated by'
      },
      {
        selector: 'itemsCount',
        name: 'items count'
      },
      {
        selector: 'additionalData.comment',
        name: 'comment'
      },
      {
        selector: 'revisionId',
        name: 'revision'
      }
    ];

    return <div className={containerStyle}>{mappings.map(o => <DiffInfoItem from={from} to={to} {...o} />)}</div>;
  }
}

export default InfoChanges;
